import React, { useState, useRef, useEffect, useMemo, useCallback } from "react";
import "react-quill/dist/quill.snow.css";
import ReactQuill, { Quill } from "react-quill";
import ReactTooltip from "react-tooltip";
import { useManageGetRequest } from "../../../../hooks/useManageGetRequest/useManageGetRequest";
import { getComponentesNuevaPlantillaAPI, getEtiquetasNuevaPlantillaAPI } from "../../../../consumers/backendApisUrls";

import 'react-quill/dist/quill.snow.css';

function Editor({ value, handleChange, placeholder, idTemplateType, setLoading }) {
  const dropdownQuillRef = useRef(null);

    const ColorStyle = Quill.import('attributors/style/color');
    const SizeStyle = Quill.import('attributors/style/size');
    const AlignStyle = Quill.import('attributors/style/align'); // Para la alineación del texto

    Quill.register(ColorStyle, true);
    Quill.register(SizeStyle, true);
    Quill.register(AlignStyle, true);

    SizeStyle.whitelist = ['14px', '16px', '18px', '20px', '24px', '32px'];
    ColorStyle.whitelist = ['red', 'blue', 'green', 'black']; // Ejemplo de colores permitidos

    const [tags, setTags] = useState([]);
  const [components, setComponents] = useState([]);
  const [newLoading, setNewLoading] = useState(true);

  const [executeGet] = useManageGetRequest();

  const setContainerStyles = () => {
    document.querySelector(".ql-container").style.minHeight = "12rem";
    document.querySelector(".ql-editor").style.minHeight = "12rem";

    document.querySelector(".ql-container").style.maxHeight = "20rem";
    document.querySelector(".ql-editor").style.maxHeight = "20rem";
  };

  const setDropdownLabel = (placeholder, query = "") => {
    let dropdownElement = document?.querySelector(`.ql-${query} .ql-picker-label`);
    if (dropdownElement) dropdownElement.innerHTML = `${placeholder} ▾`;

    let dropdownSelect = document?.querySelector(`span.ql-${query}.ql-picker span.ql-picker-options span.ql-picker-item`);
    if (dropdownSelect) dropdownSelect.classList.remove("ql-selected");
  };

  const setItemsLabel = (query) => {
    const itemsWrapper = Array.prototype.slice.call(document.querySelectorAll(`.ql-${query} .ql-picker-item`));

    itemsWrapper.forEach(item => {
      const dataValue = item.dataset.value;
      const commaIndex = dataValue.indexOf(",");

      item.textContent = dataValue.slice(0, commaIndex);
    });
  };

  const initEditorModules = async () => {
    try {
      await executeGet(getEtiquetasNuevaPlantillaAPI(idTemplateType), (res) => setTags(handleResponse(res.data, "NombreEtiqueta")));
      await executeGet(getComponentesNuevaPlantillaAPI(), (res) => setComponents(handleResponse(res.data, "NombreComponente")));
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
      setNewLoading(false);
    }
  }

  const handleResponse = (response, name) => {
    return response.map((o) => [o[name], o.Codigo]);
  };

  const genericDropdownHandler = (value, boolNewLine = false) => {
    if (value && dropdownQuillRef.current) {
      const commaIndex = value.indexOf(",");

      const cursorPosition = dropdownQuillRef.current.getEditor().getSelection().index;
      dropdownQuillRef.current.getEditor().insertText(cursorPosition, value.slice(commaIndex + 1) + (boolNewLine ? "\n\n" : ""));
      dropdownQuillRef.current.getEditor().setSelection(cursorPosition + value.length + (boolNewLine ? 2 : 0));
    }
  }

  const modules = useMemo(
    () => ({
      toolbar: {
        container: [
            [{ 'size': SizeStyle.whitelist }],
            [{ 'color': ColorStyle.whitelist }],
            [{ 'align': [] }],
            ['bold', 'italic', 'underline', 'strike'],
            // Agregando controles para listas y enlaces
            [{ 'list': 'ordered'}, { 'list': 'bullet' }], // Botones de listas
            ['link'], // Botón para enlaces e imágenes (si lo deseas)
            ['clean'], // Botón para limpiar formato
          [{ tags: tags }, { componentes: components }],
          [{ script: "sub" }, { script: "super" }], // 👈 Subíndice y superíndice
        ],
        handlers: {
          componentes: (value) => genericDropdownHandler(value, true),
          tags: (value) => genericDropdownHandler(value),
        },
      },
    }),
    [tags, components]
  );

  useEffect(() => {
    if (idTemplateType) {
      setLoading(true);
      setNewLoading(true);
      initEditorModules();
    }
  }, [idTemplateType]);

    // Define tus labels fuera del useEffect o como un useMemo para mejor práctica
    const SizeLabels = {
        '': '-',       // <-- Etiqueta para el valor 'false' (string vacío en el DOM)
        '14px': ' 14 px',
        '16px': ' 16 px',
        '18px': ' 18 px',
        '24px': ' 24 px',
        '32px': ' 32 px'
        // Asegúrate de que coincidan con SizeStyle.whitelist
    };


// ... dentro de tu componente Editor ...

    useEffect(() => {
        if (!newLoading) {
            setContainerStyles();
            setDropdownLabel("Componentes", "componentes");
            setItemsLabel("componentes");
            setDropdownLabel("Etiquetas", "tags");
            setItemsLabel("tags");

            // --- SOLUCIÓN DEFINITIVA PARA EL PICKER DE TAMAÑOS ---
            const sizePicker = document.querySelector(".ql-size");
            if (!sizePicker) return;

            const items = sizePicker.querySelectorAll(".ql-picker-item");
            items.forEach(item => {
                // Obtiene el valor, si es null o undefined lo convierte a '' (cadena vacía)
                const value = item.getAttribute("data-value") || '';

                if (SizeLabels[value]) {
                    // Limpia y fuerza el texto
                    item.innerText = SizeLabels[value];
                }
            });

            // 3. Cambiar label principal (el que se ve cuando no está abierto)
            const label = sizePicker.querySelector(".ql-picker-label");
            if (label) {
                // Limpia y fuerza el texto
                label.innerText = "";
            }

            // 🔥 4. Parche: evitar que Quill vuelva a reescribir el HTML (esto es un poco arriesgado, puedes probar sin esto primero)
            /*
            const picker = sizePicker.__quill?.theme?.tooltip;
            if (picker && picker.root) {
                // Este parche podría no ser necesario si el innerText ya está forzado.
                // Si ves que las etiquetas vuelven a "Normal", déjalo, si no, mejor quítalo.
                // picker.root.innerHTML = picker.root.innerHTML;
            }
            */
        }
    }, [newLoading, dropdownQuillRef]); // Dependencias: newLoading, dropdownQuillRef




    if (newLoading) {
    return (
      <ReactTooltip
        id="informacion-tipo-plantilla"
        place="top"
        effect="solid"
        className="tooltip-style tooltip-change-witdh"
      >
        Seleccione el tipo de plantilla
      </ReactTooltip>
    );
  }

  return (
    <div className="text-editor" name="ReactQuillEditor" style={{ borderSpacing: "1px", minHeight: "7rem" }}>
      <ReactQuill
        key="uniqueReactQuillEditor"
        theme="snow"
        onChange={handleChange}
        value={value}
        modules={modules}
        placeholder={placeholder}
        ref={dropdownQuillRef}
        formats={[
            'size', 'color', 'align',
            'bold', 'italic', 'underline', 'strike',
            'list', 'bullet', 'ordered', // Habilitar formatos de lista
            'link', // Habilitar formato de enlace
            'script', 'sub', 'super' /* ...otros formatos... */
        ]}

      />
    </div>
  );
}

export default Editor;